<template>
  <div class="content">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:left;margin-top:5px;">Apresentação de Produtos </span>
      <input type="text" placeHolder="Nome" style="height:30px;margin-left:20px;float:left;" class="inputText inputSearch" v-model="search"/>
      <div @click="clearSearch()" style="float:left;margin-top:5px;"><font-awesome-icon style="font-size:20px;color:#ffffff;margin-left:10px;" :icon="['fal', 'broom']" /></div>
      <button @click="openModalPresentation()" style="float:right;width:186px;">Nova Apresentação</button>
    </div>

    <div class="lineBox" style="margin-top:10px; min-height: 75px; min-width:1010px;">
      <div style="padding:10px; ">
        <table border="0" cellpadding="10" style="width:100%;border-collapse:collapse;border-color:#ffffff;margin:30px 0;" 
            v-for="(presentation, idx) in sortedPresentations" v-bind:key="idx">
              <thead>
              <tr style="background-color:rgba(255,255,255,0.2);">
                <td border="0"><b>Nome:</b> {{presentation.name}}</td> 
                <td colspan="2"  border="0"><!--b>Mandatório:</b> {{(presentation.mandatory===true? 'sim' : 'não')}} --></td> 
                <td  border="0" style="text-align:center;">
                  <a style="cursor:pointer;" @click="editPresentation(presentation)">
                    <font-awesome-icon style="font-siz:20px;color:#12FCC4;margin:10px;" :icon="['fal', 'edit']" />
                  </a> 
                  <a style="cursor:pointer;" @click="removePresentation(presentation)">
                    <font-awesome-icon style="font-siz:20px;color:#bb3f5c;margin:10px;" :icon="['fal', 'trash-alt']" />
                  </a> 
                </td> 
              </tr>
              <tr style="background-color:rgba(255,255,255,0.1);">
                <td colspan="4"><b>Opçoes:</b></td>
              </tr>
              <tr style="background-color:rgba(255,255,255,0.1);">
                <td style="border-bottom: 1px solid;width:200px;"><i>Id</i></td>
                <td style="border-bottom: 1px solid;"><i>Descrição</i></td>
                <td style="border-bottom: 1px solid;width:150px;"><i>Cor</i></td>
                <td style="border-bottom: 1px solid;width:120px;"><i>Imagem</i></td>
              </tr>
              <tr style="background-color:rgba(255,255,255,0.1);" v-for="(option, idx2) in presentation.options" v-bind:key="idx2">
                <td style="border-bottom: 1px solid;">{{option.id}}</td>
                <td style="border-bottom: 1px solid;">{{option.label}}</td>
                <td style="border-bottom: 1px solid;" :style="{backgroundColor:option.color}">{{option.color}}</td>
                <td style="border-bottom: 1px solid;"><img v-if="option.img" :src="getOptionImagePath + option.img" style="max-width:100px;max-height:100px;"/></td>
                
              </tr>  
              </thead>
            </table>
      </div>
    </div>

    <!-- NOVA APRESENTACAO MODAL -->

    <OpaModal  width="900" height="500" v-model="modalPresentation" header="Apresentação de Variação de Produto">
        <div style="height:320px;overflow:auto; padding:20px;">
          <div class="line" style="margin-top:0px;">
            <div class="col6" style="padding-top:0px;padding-bottom:0px;">
              Nome: <br/>
              <input type="text" class="inputText" v-model="tempPresentation.name" placeholder="Ex: Tamanho, Cores, Embalagens, etc"/><br/><br/>
            </div>
            <div class="col6" style="padding-top:0px;padding-bottom:0px;">
              <!-- Mandatório: <br/>
              Sim <input type="radio" :value="true" v-model="tempPresentation.mandatory"/>
              Não <input type="radio" :value="false" v-model="tempPresentation.mandatory"/><br/><br/>
              -->
            </div>
          </div>
          <div class="col12">
            Opções: <button @click="openModalOption()" style="width:100px;height:20px;margin-left:20px;" >Nova Opção</button><br/><br/>
              <table border="1" style="width:100%;border-color:#ffffff;border-collapse:collapse;text-align:center;">
                <tr>
                  <td>Descrição</td>
                  <td>Cor</td>
                  <td>Imagem</td>
                  <td>Ações</td>
                </tr>
                <tbody v-if="tempPresentation.options">
                <tr  v-for="(option, idx) in tempPresentation.options" v-bind:key="idx">
                  <td>{{option.label}}</td>
                  <td :style="{backgroundColor:option.color}">{{option.color}}</td>
                  <td><img v-if="option.img" :src="getOptionImagePath + option.img" style="max-width:100px;max-height:100px;"/></td>
                  <td style="text-align:center;">
                    <a @click="removeOption(idx)" style="cursor:pointer;">
                      <font-awesome-icon style="font-size:18px;color:#FF6767; margin:5px;"  :icon="['far', 'trash-alt']"/>
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
          </div>
        </div>
        <div class="modal_footer">
          <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="savePresentation()">Salvar</button>
          <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="resetPresentation(); modalPresentation=!modalPresentation">Cancelar</button>
        </div>
      </OpaModal>

      <!-- NOVA OPCAO DE APRESENTACAO MODAL -->

      <OpaModal  width="900" height="500" v-model="modalOption" header="Opção de Apresentação">
        <div style="height:320px;overflow:auto; padding:20px;">
          <div class="line" style="margin-top:0px;">
            <div class="col6" style="padding-top:0px;padding-bottom:0px;">
              Descrição: <br/>
              <input type="text" class="inputText" v-model="tempOption.label"/><br/><br/>
              Cor: <br/>
              <chrome-picker :value="colors" @input="updateColorOptionValue"></chrome-picker><br/><br/>
            </div>
            <div class="col6" style="padding-top:0px;padding-bottom:0px;position:relative;">
              Imagem: <br/>
              <OpaDragImage v-if="!tempOption.img" @uploadImage="(image) => saveOptionImage(image)"/>
              <img v-if="tempOption.img" :src="getOptionImagePath + tempOption.img" style="max-width:200px;max-height:200px;"/>
              <a v-if="tempOption.img" @click="tempOption.img = null; $forceUpdate()" style="cursor:pointer;position:absolute;top:-5px;left:100px;">
                <font-awesome-icon style="font-size:18px;color:#FF6767; margin:5px;"  :icon="['far', 'trash-alt']"/>
              </a>
            </div>
          </div>
        </div>
        <div class="modal_footer">
          <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="saveOption()">Salvar</button>
          <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="resetOption(); modalOption=!modalOption">Cancelar</button>
        </div>
      </OpaModal>


  </div>
</template>

<script>
import OpaModal from '@/components/OpaModal.vue'
import OpaDragImage from '@/components/OpaDragImage.vue'
import { EventBus } from '@/utils/event-bus'
import { Chrome } from 'vue-color'
import Presentation from '@/connection/Presentation'
import Images from '@/connection/Images'
import { mapGetters } from 'vuex'
import uuidv1 from 'uuid/v1'

export default {

  data () {
    return {
      colors: {
        hex: '#194d33',
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
      },
      search: null,
      tempPresentation: {mandatory:false},
      tempOption: null,
      modalPresentation: false,
      modalOption: false,
    }
  },

  components: {
    OpaModal, 
    'chrome-picker': Chrome,
    OpaDragImage
  },

  created () {
    if (!this.getCompany().presentations){
      let company = this.getCompany()
      company.presentations = []
      this.$store.commit('setCompany', company)

    }
    this.resetPresentation()
    this.resetOption()
  },

  computed: {

    getOptionImagePath () {
      return 'https://' + this.getCompany().Id + '/productImages/' + this.getCompany().companyId + '/'
    },

    sortedPresentations () {
      return this.getCompany().presentations
    }
  },

  methods: {

    ...mapGetters([ 'getCompany' ]),

    clearSearch () {

    },

    openModalPresentation() {
      this.resetPresentation()
      this.modalPresentation = true
    },

    editPresentation (presentation) {
      this.tempPresentation = presentation
      this.modalPresentation = true
    },

    resetPresentation () {
      this.tempPresentation = {
        mandatory: false,
        options: []
      }
    },

    async removePresentation (presentation) {
      // TODO
      if (confirm('Deseja excluir a apresentação')) {
        let presentations = this.getCompany().presentations
        presentations = presentations.filter(ap => ap.id !== presentation.id)
        EventBus.$emit('showLoading', true)
        let result = await Presentation.patchPresentations(presentations)
        EventBus.$emit('showLoading', false)
        if (result.error) {
          EventBus.$emit('showAlert', 'error', result.msg)
        } else {
          this.$store.commit('setCompany', result)
        }
      }
    },

    async savePresentation () {
      console.log(this.tempPresentation)
      EventBus.$emit('showLoading', true)
      let presentations = this.getCompany().presentations
      if (!this.tempPresentation.id) {
        this.tempPresentation.id = uuidv1()
        presentations.push(this.tempPresentation)
      }
      let result = await Presentation.patchPresentations(presentations)
      EventBus.$emit('showLoading', false)
      if (result.error) {
        EventBus.$emit('showAlert', 'error', result.msg)
        presentations.pop()
      } else {
        this.$store.commit('setCompany', result)
        this.resetPresentation()
        this.modalPresentation =! this.modalPresentation
      }
    },

    /** OPTIONS */

    openModalOption(option) {
      if (option) {
        this.tempOption = option
      }
      this.modalOption = true
    },
    
    resetOption () {
      this.tempOption = {
        id: null, 
        label: null, 
        color: null, 
        img: null
      }
    },

    updateColorOptionValue (val) {
      console.log(val.hex)
      this.tempOption.color = val.hex
    },

    

    async saveOptionImage (image) {
      if (image) {
        EventBus.$emit('showLoading', true)
        let result = await Images.saveProductOptionImage(image)
        EventBus.$emit('showLoading', false)
        if (result.error) {
          alert(result.error.msg)
        } else {
          this.tempOption.img = result
          this.$forceUpdate()
        }
      }
    },

    saveOption () {
      console.log (this.tempOption)
      if (!this.tempPresentation.options){
        this.tempPresentation.options = []
      }
      if (!this.tempOption.id) {
        this.tempOption.id = uuidv1()
      }
      this.tempPresentation.options.push(this.tempOption)
      this.resetOption()
      this.modalOption =! this.modalOption
    },

    removeOption (idx) {
      console.log(idx)
      this.tempPresentation.options.splice(idx,1)
      this.$forceUpdate()
    }
  }

}
</script>

<style lang="scss" scoped>

.inputLabel {	color: #FFFFFF;	font-family: Roboto;	font-size: 14px; margin-bottom:10px;}

/* Esconde o input */
input[type='file'] {
  display: none;


}

label {
    width:120px;
    position:absolute;
    right:5px;
    top:5px;
    cursor: pointer;

    text-decoration:underline;
    color: #12FCC4;
    font-family: Roboto;	font-size: 14px;
  }


</style>